<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
}
</script>

<style lang="scss">
@import "~bootstrap/dist/css/bootstrap.css"


</style>



// WEBPACK FOOTER //
// App.vue?31841611